<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.alias", :label="translations.label.alias", :disabled="true")
          v-col(cols="12" sm="6" md="4")
            BaseChipSelectField(rules="required", :multiple="false", :items="providersList" v-model="form.provider", :label="translations.label.provider")
          v-col(cols="12" sm="6" md="4")
            BaseSelectField(rules="required", :items="gameType", v-model="form.type", :label="translations.label.type")
          v-col(cols="12" sm="6" md="4")
            BaseSelectField(rules="required", :items="licenses" v-model="form.license", :label="translations.label.license")
          v-col(cols="12" sm="6" md="4")
            BaseDatePicker(rules="required" v-model="form.launchdate", :label="translations.label.launchdate")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required|host" v-model="form.image", :label="translations.label.image")
          v-col(cols="12" sm="6" md="4")
            BaseFloatField(v-model="form.teoricRTP", :label="translations.label.teoricRTP" min="0" max="100" decimals="2")
          v-col(cols="12" sm="6" md="4")
            v-checkbox.mt-0(v-model="form.freespins", :label="translations.label.freespins")
          v-col(cols="12")
            BaseChipSelectField(rules="required", :items="jurisdictions" v-model="form.jurisdictions", :label="translations.label.jurisdictions")
        v-row
          v-col(cols="12" sm="6")
            fieldset.fantasy__fieldset--basic
              legend 
                v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                | Platform:
              v-row
                BaseTextField.d-none(rules="required" v-model="form.platform.selected" type="hidden", :disabled="true")
                v-col.py-0(cols="12" sm="6")
                  v-checkbox.mt-0(v-model="form.platform.mobile" label="Mobile" @change="platformClicked")
                v-col.py-0(cols="12" sm="6")
                  v-checkbox.mt-0(v-model="form.platform.desktop" label="Desktop" @change="platformClicked")
          v-col(cols="12" sm="6")
            fieldset.fantasy__fieldset--basic
              legend 
                | Mode:
              v-row
                v-col.py-0(cols="12" sm="6")
                  v-checkbox.mt-0(v-model="form.mode.fun", :label="translations.label.fun")
        v-row.pt-4
          v-col(cols="12" sm="6").pb-0
            v-slider(v-model="form.volatility", step="1", min="1", max="5", thumb-label="always", :thumb-size="24", ticks="always", tick-size="3", :label="translations.label.volatility")
          v-col(cols="12" sm="6").pb-0
            v-checkbox.mt-0(v-model="form.jackpot", :label="translations.label.jackpot")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend
                | {{ translations.label.bet.title }}:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseFloatField(v-model="form.bet.default", :label="translations.label.bet.default" min="0" decimals="2")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseFloatField(v-model="form.bet.min", :label="translations.label.bet.min" min="0" decimals="2")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseFloatField(v-model="form.bet.max", :label="translations.label.bet.max" min="0" decimals="2")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseFloatField(v-model="form.bet.highest", :label="translations.label.bet.highest" min="0" decimals="2")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseFloatField(v-model="form.bet.mwm", :label="translations.label.bet.mwm" min="0" decimals="2")
        v-row
          v-col(cols="12").py-4
            v-expansion-panels(accordion)
              v-expansion-panel
                v-expansion-panel-header
                  p.title.ma-0 {{ translations.label.extrafields }}
                v-expansion-panel-content
                  v-divider.mb-4
                  BaseDynamicField(v-model="form.params" ref="dynamicField")
        v-row
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.buttons.edit }}

</template>

<script>

  import { jurisdictions, licenses, gameType } from "@/store/variablesGlobals";

  export default {
    name: "GameEdit",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      providersList:{
        type: Array,
        default: function(){
          return []
        }
      },
      game: {
        type: Object,
        default: function(){
          return {}
        }
      }
    },
    data:() => ({
      form: {
        name: null,
        alias: null,
        provider: null,
        type: null,
        license: null,
        jurisdictions: null,
        platform: {
          mobile: false,
          desktop: false,
          selected: null,
        },
        image: null,
        launchdate: null,
        teoricRTP: null,
        mode: {
          fun: null,
        },
        freespins: null,
        volatility: 1,
        jackpot: false,
        bet: {
          default: '0',
          min: '0',
          max: '0',
          highest: '0',
          mwm: '0',
        },
        params: [],
      },
      gameType,
      jurisdictions,
      licenses,
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editGame.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editGame.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200) {
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          _id: this.game._id,
          data: {
            name: this.form.name,
            alias: this.form.alias,
            provider: this.form.provider.value,
            type: this.form.type,
            license: this.form.license,
            image: this.form.image,
            jurisdictions: this.form.jurisdictions.map((item)=>{return item.value}),
            launchdate: this.$moment(this.form.launchdate, "DD/MM/YYYY").format('YYYY-MM-DD'),
            platform: {},
            volatility: this.form.volatility,
            jackpot: this.form.jackpot,
            bet: {
              default: this.form.bet.default,
              min: this.form.bet.min,
              max: this.form.bet.max,
              highest: this.form.bet.highest,
              mwm: this.form.bet.mwm,
            }
          },
        };
        if(this.form.platform.mobile){
          formSend.data.platform.mobile = true;
        }
        if(this.form.platform.desktop){
          formSend.data.platform.desktop = true;
        }
        if(this.form.teoricRTP != null){
          formSend.data.teoricRTP = this.form.teoricRTP;
        }
        if(this.form.mode.fun){
          formSend.data.mode = {};
          formSend.data.mode.fun = true;
        }
        if(this.form.freespins){
          formSend.data.freespins = true;
        }
        if (this.form.params.length){
          formSend.data.params = {};
          this.form.params.forEach((item) => {
            formSend.data.params[item.key] = item.value
          });
        }
        this.$store.dispatch('editGame', formSend);
      },
      setFields(){
        this.form.name = this.game.name;
        this.form.alias = this.game.alias;
        this.form.provider = { text: this.game.provider.n, value: this.game.provider._id };
        this.form.type = this.game.type;
        this.form.license = this.game.license;
        this.form.jurisdictions = this.game.jurisdictions;
        this.form.platform.mobile = this.game.platform.mobile;
        this.form.platform.desktop = this.game.platform.desktop;
        this.form.launchdate = this.game.launchdate;
        this.form.image = this.game.image;
        this.form.teoricRTP = this.game.teoricRTP;
        this.form.mode.fun = this.game.mode.fun;
        this.form.freespins = this.game.freespins;
        this.form.volatility = this.game.volatility;
        this.form.jackpot = this.game.jackpot;
        this.form.bet.default = this.game.bet.default;
        this.form.bet.min = this.game.bet.min;
        this.form.bet.max = this.game.bet.max;
        this.form.bet.highest = this.game.bet.highest;
        this.form.bet.mwm = this.game.bet.mwm;
        this.form.params = this.game.provider.params ? this.changeObjectToArray(this.provider.params) : [];
        this.platformClicked();
      },
      platformClicked(){
        this.form.platform.selected = this.form.platform.mobile || this.form.platform.desktop ? 'selected' : '';
      },
    }
  }
</script>

<style lang="sass">
</style>